import { createIcon } from '@chakra-ui/icons';

export const LaptopApps = createIcon({
  displayName: 'LaptopApps',
  viewBox: '0 0 24 19',
  path: [
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 15V17C0 18.1046 0.89543 19 2 19H22C23.1046 19 24 18.1046 24 17V15H17C17 15.5523 16.5523 16 16 16H8C7.44771 16 7 15.5523 7 15H0Z"
        fill="currentColor"
      />
      <path
        d="M2 3C2 1.34315 3.34315 0 5 0H11V2H5C4.44772 2 4 2.44772 4 3V13H2V3Z"
        fill="currentColor"
      />
      <path
        d="M21 4C22.1046 4 23 3.10457 23 2C23 0.89543 22.1046 0 21 0C19.8954 0 19 0.89543 19 2C19 3.10457 19.8954 4 21 4Z"
        fill="currentColor"
      />
      <path
        d="M21 10C22.1046 10 23 9.1046 23 8C23 6.89543 22.1046 6 21 6C19.8954 6 19 6.89543 19 8C19 9.1046 19.8954 10 21 10Z"
        fill="currentColor"
      />
      <path
        d="M15 4C16.1046 4 17 3.10457 17 2C17 0.89543 16.1046 0 15 0C13.8954 0 13 0.89543 13 2C13 3.10457 13.8954 4 15 4Z"
        fill="currentColor"
      />
      <path
        d="M15 10C16.1046 10 17 9.1046 17 8C17 6.89543 16.1046 6 15 6C13.8954 6 13 6.89543 13 8C13 9.1046 13.8954 10 15 10Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
